module.exports = __webpack_public_path__ + "static/media/folder.c3b04cab.png";